import {
  EDIT_GLOBAL_PARAM,
  FETCH_GLOBAL_PARAMS
} from "../actions/actionTypes";

const defaultState = {
  //lista ze wszystkimi parametrami globalnymi
  globalParamList: []
};

export default function globalParamReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_GLOBAL_PARAMS: {
      return {
        ...state,
        globalParamList: action.payload
      };
    }
    case EDIT_GLOBAL_PARAM:
      return {
        ...state,
        globalParamList: state.globalParamList.map(globalParam =>
          globalParam.id === action.payload.id ? action.payload : globalParam
        )
      };
    default:
      return state;
  }
}
